import { Stack } from "@mantine/core";
import { createFileRoute } from "@tanstack/react-router";

import { DashboardComponents } from "@/features/dashboard/_components/dashboard";
import { CustomerForm } from "@/features/dashboard/clientes/components/CustomerForm";

export const Route = createFileRoute("/_private/dashboard/_base/clientes/editar/$id/")({
  component: RouteComponent
});

function RouteComponent() {
  const { id } = Route.useParams();

  return (
    <Stack>
      <DashboardComponents.Title>Editar Cliente</DashboardComponents.Title>

      <CustomerForm id={id} />
    </Stack>
  );
}
